import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { ContragentAutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/contragent-auto-complete/contragent-auto-complete.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-contragent-deleting-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ContragentAutoCompleteComponent],
  templateUrl: './contragent-deleting-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContragentDeletingModalComponent {
  public contragent: ContragentFindInterface;

  public previousContragentIds: number[] = [];

  public constructor(private readonly config: DynamicDialogConfig, public readonly ref: DynamicDialogRef) {
    if (config.data?.previousContragentId) {
      this.previousContragentIds = [config.data?.previousContragentId];
    }
  }
}
